export default "__VITE_ASSET__DZGhmfjd__"